import { render, staticRenderFns } from "./services.vue?vue&type=template&id=22cf8d97&scoped=true"
import script from "./services.vue?vue&type=script&lang=ts"
export * from "./services.vue?vue&type=script&lang=ts"
import style0 from "./services.vue?vue&type=style&index=0&id=22cf8d97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf8d97",
  null
  
)

export default component.exports